import { Gauge } from "lucide-react";

import type {
  MeasurementToolsetRailController,
  ViewportToolsetRailRendererResult,
} from "@/viewport-tools/rail/types";
import { MEASUREMENT_TOOLSET, getMeasurementToolDefinition } from "./registry";
import { MeasurementToolsetPanel } from "@/viewport-tools/measurement/rail-panel";

export function renderMeasurementToolsetRail(
  controller: MeasurementToolsetRailController
): ViewportToolsetRailRendererResult {
  return {
    item: {
      id: MEASUREMENT_TOOLSET.id,
      icon: <Gauge className="size-4" />,
      label: MEASUREMENT_TOOLSET.label,
      sublabel: controller.activeTool
        ? `${getMeasurementToolDefinition(controller.activeTool).label}${controller.activeMeasurementType ? ` ${controller.activeMeasurementType}` : ""}`
        : undefined,
      active: !!controller.activeTool,
      selected: controller.expanded,
      disabled: !controller.scale,
      onClick: () => controller.setExpanded(!controller.expanded),
      showExpandedIndicator: controller.expanded,
    },
    inlineContent:
      controller.scale && controller.expanded ? (
        <MeasurementToolsetPanel
          measurementTools={controller.measurementTools}
          activeTool={controller.activeTool}
          activeMeasurementType={controller.activeMeasurementType}
          onToolSelect={controller.selectTool}
          onTypeSelect={controller.selectMeasurementType}
          snapEnabled={controller.snapEnabled}
          onSnapToggle={controller.toggleSnap}
          incrementSnapEnabled={controller.incrementSnapEnabled}
          onIncrementSnapToggle={controller.toggleIncrementSnap}
          incrementStepFeet={controller.incrementStepFeet}
          onIncrementStepChange={controller.setIncrementStepFeet}
          showHeightInput={controller.showHeightInput}
          heightValue={controller.heightValue}
          onHeightChange={controller.setHeightValue}
          textLocked={controller.textLocked}
          onTextLockToggle={controller.toggleTextLock}
          textFontSize={controller.textFontSize}
          onTextFontSizeChange={controller.setTextFontSize}
        />
      ) : null,
  };
}
